import commonAssets from './commonAssets';
import AssetLoader from './assetLoader';

export const loadCommonSfx = async () => {
  const { images } = commonAssets;
  const assetLoader = new AssetLoader();

  Object.values(images).forEach(value => assetLoader.queueImage(value));
  const cache = await assetLoader.downloadAll();

  return cache;
};

export const loadApplicationAssets = async () => {
  const {
    audio: { application: applicationAudio }
  } = commonAssets;
  const assetLoader = new AssetLoader();

  Object.values(applicationAudio).forEach(value => assetLoader.queueAudio(value));
  const cache = await assetLoader.downloadAll();

  return cache;
};

export const loadModuleAssets = async moduleAssets => {
  const assetLoader = new AssetLoader();

  Object.values(moduleAssets).forEach(asset => {
    return Array.isArray(asset)
      ? asset.forEach(entry => assetLoader.queueAudio(entry))
      : assetLoader.queueAudio(asset);
  });

  const cache = await assetLoader.downloadAll();

  const moduleRewardSounds = Object.keys(moduleAssets).reduce((map, key) => {
    map[key] = Array.isArray(moduleAssets[key])
      ? getSoundsArray(moduleAssets[key], cache)
      : cache.get(moduleAssets[key].src);

    return map;
  }, {});
  return { ...moduleRewardSounds };
};

export const getSoundsArray = (assets, cache) => {
  let rewardSounds = [];
  assets.forEach(audio => {
    rewardSounds.push(cache.get(audio.src));
  });

  return rewardSounds;
};
